<template>
  <div class="users">
    <loader-box v-if="loading"/>
    <p class="well well-sm">Cette liste en version bêta contient tous les utilisateurs de la base avec facilité de recherche contrairement à la version simple ou il n'est pas possible de faire un tris sur tous les utilisateurs. Cette liste a en revanche l'inconvénient de se charger plus lentement dû au nombre mais seulement lors du premier chargement. (oui il y un système de cache)</p>
    <div class="row">
      <div class="col-sm-4 col-sm-offset-8">
        <div class="input-group">
          <input type="text" class="form-control bg-ash" v-model="query" placeholder="Recherche..." aria-describedby="search-icon">
          <span class="input-group-addon" id="search-icon"><i class="fa fa-search"></i></span>
        </div>
      </div>
    </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>ID</th>
          <th>Prénom</th>
          <th>Nom</th>
          <th>Tél</th>
          <th>nb_réservations</th>
          <th>Role</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="user in filteredUsers">
        <td>{{ user.id }}</td>
        <td>{{ user.first_name }}</td>
        <td>{{ user.last_name }}</td>
        <td>{{ user.phone_number }}</td>
        <td>{{ user.booking_count }}</td>
        <td>{{ user.role_text }}</td>
        <td class="inline-actions">
          <a :href="userUrl(userShowUrl, user.id)" data-toggle="tooltip" data-placement="top" title="Détails"><i
            class="fa fa-eye"></i></a>
          <a :href="userUrl(userEditUrl, user.id)" data-toggle="tooltip" data-placement="top" title="Modifer"><i
            class="fa fa-edit"></i></a>
          <a :href="userUrl(userDeleteUrl, user.id)" data-method="DELETE"
             :data-confirm="'Supprimer '+ user.full_name +' ?'" data-toggle="tooltip" data-placement="top"
             title="Supprimer"><i
            class="fa fa-trash"></i></a>
          <a :href="userUrl(userMakeAdminUrl, user.id)" data-method="POST"
             :data-confirm="'Faire de '+user.full_name + ' un agent ?'" data-toggle="tooltip" data-placement="top"
             title="Définir en tant qu'agent"><i
            class="fa fa-user-secret"></i></a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

  import axios from 'axios'
  import AppApiResponse from '../../AppApiResponse'
  import LoaderBox from '../Loader/LoaderBox'
  import dataMethod from '../../data-method'

  export default {
    props: {
      userIndexUrl: {type: String},
      userShowUrl: {type: String},
      userEditUrl: {type: String},
      userDeleteUrl: {type: String},
      userMakeAdminUrl: {type: String}
    },
    components: {LoaderBox},
    data () {
      return {
        query: '',
        loading: false,
        users: [],
      }
    },
    computed: {
      filteredUsers () {
        if (this.query.length < 3) {
          return this.users
        }
        return this.users.filter(user => {
          return (user.first_name && user.first_name.toLocaleLowerCase().includes(this.query.toLocaleLowerCase()))
            || (user.last_name && user.last_name.toLocaleLowerCase().includes(this.query.toLocaleLowerCase()))
            || (user.phone_number && user.phone_number.toLocaleLowerCase().includes(this.query.toLocaleLowerCase()))
            || (user.email && user.email.toLocaleLowerCase().includes(this.query.toLocaleLowerCase()))
        })
      }
    },
    methods: {
      userUrl (url, id) {
        return url.replace(':user', id)
      }
    },
    mounted () {
      this.loading = true
      // let usersString = window.sessionStorage.getItem('users')
      // if (usersString) {
      //   this.users = JSON.parse(usersString)
      //   this.loading = false
      //   return
      // }
      axios({
        method: 'GET',
        // headers: {
        //   'Authorization': 'Bearer ' + 5455
        // },
        url: this.userIndexUrl
      })
        .then(response => {
          let apiResponse = new AppApiResponse(response)
          if (apiResponse.isSuccess()) {
            this.users = apiResponse.getData()
            // window.sessionStorage.setItem('users', JSON.stringify(this.users))
            dataMethod()
          } else {
            console.error(apiResponse)
            debugger
          }
        })
        .catch(error => {
          let apiResponse = new AppApiResponse(error)
          debugger
        })
        .then(_ => this.loading = false)
    }
  }

</script>

<style>
  .users {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/component/User/Users.vue